import { EmployeeWorkingHours, ViewEmployee } from '../../models'
import { DEFAULT_EMPLOYEE_INFO } from './Info'
import { DEFAULT_EMPLOYEE_SETTINGS } from './Settings'

export const DEFAULT_EMPLOYEE: Omit<ViewEmployee, 'id'> = {
  active: false,
  name: '',
  settings: DEFAULT_EMPLOYEE_SETTINGS,
  info: DEFAULT_EMPLOYEE_INFO,
  order: 0,
  workingHours: [],
  services: [],
  absences: [],
}

export const DEFAULT_WORKING_HOURS: Omit<EmployeeWorkingHours, 'id'> = {
  to: '',
  from: '',
  weekdays: [],
}
